export const ErrorCodes = {
  INVALID_REQUEST: 'INVALID_REQUEST',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
  LIMIT_EXCEEDED: 'LIMIT_EXCEEDED',
  INVALID_PARTNER_TYPE: 'INVALID_PARTNER_TYPE',
  ORDER_ALREADY_COMPLETE: 'ORDER_ALREADY_COMPLETE',
  ORDER_HAS_ACTIVE_SHIPMENTS: 'ORDER_HAS_ACTIVE_SHIPMENTS',
  ORDER_CANNOT_BE_EDITED: 'ORDER_CANNOT_BE_EDITED',
  ORDER_CANNOT_BE_CONFIRMED: 'ORDER_CANNOT_BE_CONFIRMED',
  PARTNER_MISMATCH: 'PARTNER_MISMATCH',
  DUPLICATE_ITEM: 'DUPLICATE_ITEM',
  SHIPMENT_ALREADY_PACKED: 'SHIPMENT_ALREADY_PACKED',
  NON_TERMINAL_SHIPMENTS: 'NON_TERMINAL_SHIPMENTS',
} as const;

export type ErrorCode = typeof ErrorCodes[keyof typeof ErrorCodes];
